import type { Testkit, UniDriver } from 'ricos-types/testkit';
import { dataHook } from 'wix-rich-content-common';

import { TITLE_BUTTON_DATA_HOOK } from './data-hooks';

export type TitleTestkit = Testkit<{
  content: object;
  toolbars: {
    createTextButtonToolbars: (getTextButtonBase: () => UniDriver<Element>) => {
      click: () => Promise<void>;
    };
  };
}>;

export const createTitleTestkit: TitleTestkit = () => {
  return {
    content: {},
    toolbars: {
      createTextButtonToolbars: getTextButtonBase => ({
        click: async () => {
          await getTextButtonBase().$(dataHook(TITLE_BUTTON_DATA_HOOK)).click();
        },
      }),
    },
  };
};
